import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLenis } from "../hooks/useLenis";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Catalog } from "../components/Catalog";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";

export default function Home() {
    useLenis();
    const [products, setProducts] = useState([]);
    const [whatsapp, setWhatsapp] = useState("");
    const [category, setCategory] = useState("todos");

    useEffect(() => {
        Promise.all([api.get("/products"), api.get("/settings")])
            .then(([p, s]) => {
                setProducts(p.data);
                setWhatsapp(s.data.whatsapp_number || "");
            })
            .catch(() => {});
    }, []);

    const selectAndScroll = (id) => {
        setCategory(id);
        requestAnimationFrame(() =>
            document.getElementById("catalogo")?.scrollIntoView({ behavior: "smooth" }),
        );
    };

    return (
        <div
            data-testid="home-page"
            className="grain min-h-screen bg-[#0B0B0B] text-white overflow-x-clip"
        >
            <Header category={category} onSelect={selectAndScroll} />
            <Hero onSelect={selectAndScroll} />
            <Marquee />
            <Catalog
                products={products}
                category={category}
                setCategory={setCategory}
                whatsapp={whatsapp}
            />
            <Footer whatsapp={whatsapp} />
            <WhatsAppFloat number={whatsapp} />
        </div>
    );
}
